import React from 'react';

import PropTypes from 'prop-types';

import {
    Typography,
} from 'wanderu-components';
import { shortDaysOfWeek } from 'wanderu-utils';

import styles from './DepartSchedule.scss';

const DepartSchedule = ({ days, locale, className }) => {
    const departStrings = shortDaysOfWeek(days, locale);
    return (
        <ol className={className}>
            {departStrings.map((dayString, index) => (
                <Typography
                    className={styles.departScheduleItem}
                    component="li"
                    key={index}
                    variant="caption"
                >
                    {index + 1 < departStrings.length
                        ? `${dayString},`
                        : dayString}
                </Typography>
            ))}
        </ol>
    );
};

DepartSchedule.propTypes = {
    days: PropTypes.array.isRequired,
    locale: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
};

export default DepartSchedule;
